export enum KeyPairType {
    None = 'None',
    RTS_PatientPaymentMethodCode = 'RTS_PatientPaymentMethodCode',
    RTS_StateCountryCode = 'RTS_StateCountryCode',
    RTS_CountryCode = 'RTS_CountryCode',
    RTS_DebitAccountType = 'RTS_DebitAccountType',
}